import Vue from "vue";
import Router from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            redirect: {
                name: "index"
            },
            meta: {
                requireAuth: false
            },
        },
        {
            path: "/transfer/contest",
            name: "transfer-contest",
            meta: {
                requireAuth: false
            },
            component: () =>
                import("@/views/app/transfer-contest.vue"),
        },
        {
            path: "/transfer/training",
            name: "transfer-training",
            meta: {
                requireAuth: false
            },
            component: () =>
                import("@/views/app/transfer-training.vue"),
        },
        {
            path: "/transfer/login",
            name: "transfer-login",
            meta: {
                requireAuth: false
            },
            component: () =>
                import("@/views/account/transfer-login.vue"),
        },
        {
            path: "/app",
            name: "home",
            component: () =>
                import("@/layouts/app/Basiclayout"),
            children: [
                {
                    path: "/index",
                    name: "index",
                    meta: {
                        title: "鹿客竞练 - 开放式竞赛与训练平台 - JS.SKILLBOX.CN",
                        code: "index",
                        requireAuth: false,
                        description: '鹿客竞练是专业的1+X在线竞赛与训练平台,包括1+X竞练、学业水平测试、校内赛、省赛等，是职业教育以赛促教、以赛促学的关键平台。',
                        keywords: '学业水平测试、1+X训练、职业技能等级证书、竞练系统、竞赛平台'
                    },
                    component: () =>
                        import("@/views/app/home")
                },
                {
                    path: "/contest",
                    name: "contest",
                    meta: {
                        title: "竞赛 - 随时随开始你的竞赛 - JS.SKILLBOX.CN",
                        code: "contest",
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/app/contest")
                },
                {
                    path: "/train",
                    name: "training",

                    meta: {
                        title: "训练 - 技能训练与测评 - JS.SKILLBOX.CN",
                        code: "training",
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/app/training")
                },
                {
                    path: "/classroom",
                    name: "classroom-index",

                    meta: {
                        title: "专题 - 技能训练与测评 - JS.SKILLBOX.CN",
                        code: "training",
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/app/classroom")
                },
                {
                    path: "/index/rank",
                    name: "rank",
                    meta: {
                        title: "排行榜 - 技能训练与测评 - JS.SKILLBOX.CN",
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/app/rank")
                },
                {
                    path: "/notify",
                    name: "notify",
                    component: () =>
                        import("@/views/app/notify"),
                    meta: {
                        requireAuth: false
                    },
                }
            ]
        },
        {
            path: "/admin",
            name: "admin",
            meta: {
                title: "鹿课开放平台",
                requireAuth: true
            },
            redirect: '/admin/index'
        },
        {
            path: "/admin",
            component: () =>
                import("@/layouts/admin/Basiclayout"),
            children: [
                {
                    path: "index",
                    meta: {
                        requireAuth: true
                    },
                },
                {
                    path: "user",
                    name: "user-manage",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/user-manage")
                },
                {
                    path: "roles",
                    name: "system-roles",
                    meta: {
                        permissions: 'admin_role_manage',
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/system-roles")
                },
                {
                    path: "/admin/competition-center",
                    meta: {
                        title: "创作中心",
                        requireAuth: true
                    },
                    name: "competition-center",
                    redirect: "/admin/competition-center/list",
                    component: {
                        render: h => h("router-view")
                    },
                    children: [
                     
                        {
                            path: "list",
                            name: "course-list",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/course-list")
                        },
                        {
                            path: "manage",
                            name: "course-manage",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/course-manage"),
                        },
                        {
                            path: "category",
                            name: "course-category-manage",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/course-category-manage"),
                        },
                        {
                            path: "tag-manage",
                            name: "course-tag-manage",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/course-tag-manage"),
                        },
                        {
                            path: "tag-group-manage",
                            name: "course-tag-group-manage",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/course-tag-group-manage"),
                        },

                    ]
                },
                {
                    path: "classroom",
                    redirect: "/admin/classroom/manage",
                    meta: {
                        requireAuth: true
                    },
                    component: {
                        render: h => h("router-view")
                    },
                    children: [
                        {
                            path: "manage",
                            name: "classroom-manage",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/classroom-manage"),
                        },
                        {
                            path: "competition",
                            name: "classroom-competitions",
                            meta: {
                                requireAuth: true
                            },
                            component: () =>
                                import("@/views/admin/classroom-competitions"),
                        },
                    ]
                },
            ]
        },
        {
            path: "/admin/course-set",
            // meta: { title: "" },
            component: () =>
                import("./layouts/admin/CourseSet"),
            children: [
                {
                    path: ":competitionId/base",
                    name: "contest-base",
                    meta: {
                        title: "课程信息",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/contest-base")
                },
                {
                    path: ":competitionId/content",
                    name: "course-content",
                    meta: {
                        title: "比赛内容",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/contest/create-content")
                },
                {
                    path: ":competitionId/config",
                    name: "course-config",
                    meta: {
                        title: "比赛设置",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-config")
                },
                {
                    path: ":competitionId/resource",
                    name: "course-resource",
                    meta: {
                        title: "课程资源",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-resource")
                },
                {
                    path: ":competitionId/judge",
                    name: "course-judge",
                    meta: {
                        title: "评委设置",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-judge")
                },
                {
                    path: ":competitionId/mark",
                    name: "course-mark",
                    meta: {
                        title: "比赛批改",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/mark-list")
                },
                {
                    path: ":competitionId/member",
                    name: "course-member",
                    meta: {
                        title: "参赛者管理",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-member")
                },
                {
                    path: ":competitionId/member/quit",
                    name: "course-member-quit",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-member-quit")
                },
                {
                    path: ":competitionId/member/check",
                    name: "course-member-check",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/course-member-check")
                },
                {
                    path: ":competitionId/training",
                    name: "training-base",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/training-base")
                },
                {
                    path: ":competitionId/training-mark",
                    name: "train-mark-list",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/train/train-mark-list")
                },
                {
                    path: ":competitionId/replay",
                    name: "replay-mark-list",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/replay-mark-list")
                }
            ]
        },
        {
            path: "/admin/special",
            component: () =>
                import("./layouts/admin/Classroom"),
            children: [
                {
                    path: ":classroomId/base",
                    name: "classroom-base",
                    meta: {
                        title: "课程信息",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/classroom-base")
                },
                {
                    path: ":classroomId/contest",
                    name: "classroom-contest",
                    meta: {
                        title: "专题管理",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/classroom-contest")
                },
                {
                    path: ":classroomId/judge",
                    name: "classroom-judge",
                    meta: {
                        title: "评委设置",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/classroom-judge")
                },
                {
                    path: ":classroomId/member",
                    name: "classroom-member",
                    meta: {
                        title: "参赛者管理",
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/classroom-member")
                },
                {
                    path: ":classroomId/member/quit",
                    name: "classroom-member-quit",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/classroom-member-quit")
                }
            ],
        },
        {
            path: "/admin/special/:classroomId/competition/:competitionId",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("./layouts/admin/ClassroomSet"),
            children: [
                {
                    path: "base",
                    name: "classroom-contest-base",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/contest-base")
                },
                {
                    path: "training",
                    name: "classroom-training-base",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/admin/training-base")
                },
                {
                    path: "contest-mark",
                    name: "special-contest-mark",
                    meta: {
                        title: "比赛批改",
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/show/contest-special-mark-list")
                },
                {
                    path: "training-mark",
                    name: "special-training-mark",
                    meta: {
                        title: "训练批改",
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-special-mark-list")
                },
            ]
        },
        /**比赛内容创建 */
        {
            path: "/contest/create-paper",
            name: "create-paper",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("@/views/contest/create-paper")
        },
        {
            path: "/contest/paper-preview",
            name: "paper-preview",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("@/views/contest/paper-preview")
        },
        /**比赛内容创建 */
        /**比赛内容呈现 */
        {
            path: "/contest/index",
            component: () =>
                import("@/views/competition/index"),
            children: [
                {
                    path: ":competitionId/introduce",
                    name: "competition-introduce",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/show/competition-desc")
                },
                {
                    path: ":competitionId/index",
                    name: "competition-index",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/index")
                },
                {
                    path: ":competitionId/rank-list",
                    name: "competition-rank-list",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/rank-list")
                }
            ]
        },
        {
            path: "/show/entrance/:competitionId",
            name: "entrance",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/entrance")
        },
        {
            path: "/show/exercise",
            name: "exercise",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/do-exercise")
        },
        {
            path: "/show/result/:competitionId/:paperId/:times/:classroom_id/:replay_type",
            name: "result",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/view-result")
        },
        {
            path: "/show/competition-result/:competitionId/:studentId/:times/:classroom_id/:replay_type",
            name: "competition-result",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/competition-result")
        },
        {
            path: "/show/grade/:competitionId",
            name: "competition-grade",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/competition/competition-grade")
        },
        {
            path: "/show/correct-papers",
            name: "correct-papers",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/correct-papers")
        },
        {
            path: "/show/preview/:paperId",
            name: "preview",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/show/paper-preview")
        },
        {
            path: "/show/replay-grade/:competitionId",
            name: "replay-grade",
            meta: {
                requireAuth: true
            },
            props: {
                default: true
            },
            component: () =>
                import("@/views/competition/replay-grade")
        },
        /**比赛内容呈现 */
        /*训练内容呈现 */
        {
            path: "/train",
            component: {
                render: h => h("router-view")
            },
            children: [
                {
                    path: "index/:competitionId",
                    name: "train-index",
                    meta: {
                        requireAuth: false
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-index")
                },
                {
                    path: "list/:competitionId/:taskId",
                    name: "train-item-list",
                    meta: {
                        requireAuth: false
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-item-list")
                },
                {
                    path: "exercise",
                    name: "train-exercise",
                    meta: {
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-exercise")
                },
                {
                    path: "revise",
                    name: "train-revise",
                    meta: {
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-revise")
                },
                {
                    path: "result/:competitionId/:paperId/:classroomId/:replay_type",
                    name: "train-view-result",
                    meta: {
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-view-result")
                },
                {
                    path: "correct-paper",
                    name: "train-correct-paper",
                    meta: {
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/train/train-correct-paper")
                },
                {
                    path: "grade/:competitionId",
                    name: "train-grade",
                    meta: {
                        requireAuth: true
                    },
                    props: {
                        default: true
                    },
                    component: () =>
                        import("@/views/competition/training-grade")
                }
            ]
        },
        /*训练内容呈现 */
        /*专题内容呈现 */
        {
            path: "/classroom/index",
            meta: {
                requireAuth: false
            },
            component: () =>
                import("@/views/classroom/index"),
            children: [
                {
                    path: ":classroomId/path",
                    name: "classroom-path",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/classroom/path")
                },
                {
                    path: ":classroomId/activity",
                    name: "activity",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/classroom/activity")
                },
            ]
        },
        /*专题内容呈现 */
        {
            path: "/account/:type",
            name: "login",
            meta: {
                requireAuth: false
            },
            component: () =>
                import("@/views/account/login.vue")
        },
        /*重现赛 */
        {
            path: "/contest/replay",
            component: () =>
                import("@/views/competition/replay"),
            children: [
                {
                    path: ":competitionId/:times/introduce",
                    name: "replay-introduce",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/show/competition-desc")
                },
                {
                    path: ":competitionId/:times/index",
                    name: "replay-index",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/index")
                },
                {
                    path: ":competitionId/:times/rank-list",
                    name: "replay-rank-list",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/rank-list")
                }
            ]
        },
        /*重现赛 */
        /*专题比赛*/
        {
            path: "/contest/special",
            component: () =>
                import("@/views/competition/special"),
            children: [
                {
                    path: ":classroomId/:competitionId/:times/introduce",
                    name: "special-introduce",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/show/competition-desc")
                },
                {
                    path: ":classroomId/:competitionId/:times/index",
                    name: "special-index",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/special-index")
                },
                {
                    path: ":classroomId/:competitionId/:times/rank-list",
                    name: "special-rank-list",
                    meta: {
                        requireAuth: true
                    },
                    component: () =>
                        import("@/views/show/rank-list")
                }
            ]
        },
        /*专题比赛*/
        /*专题训练 */
        {
            path: "/train",
            component: {
                render: h => h("router-view")
            },
            children: [
                {
                    path: "special/:classroomId/:competitionId/:replayType",
                    name: "train-special-index",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/train/train-special-index")
                },
                {
                    path: "special-list/:classroomId/:competitionId/:replayType/:taskId",
                    name: "train-special-item-list",
                    meta: {
                        requireAuth: false
                    },
                    component: () =>
                        import("@/views/train/train-special-item-list")
                }
            ]

        },
        /*专题训练 */
        {
            path: "/special/special-contest-grade/:classroomId/:competitionId",
            name: "special-contest-grade",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("@/views/competition/special-contest-grade")
        },
        {
            path: "/special/special-training-grade/:classroomId/:competitionId",
            name: "special-training-grade",
            meta: {
                requireAuth: true
            },
            component: () =>
                import("@/views/competition/special-training-grade")
        },
        {
            path: "*",
            name: "404",
            component: () =>
                import("@/views/exception/404"),
            meta: {
                title: "404",
                requireAuth: false
            }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        };
    }
});
router.beforeEach((to, from, next) => {
    if (to.path !== from.path) {
        NProgress.start();
    }

    next();
});

router.afterEach(() => {
    NProgress.done();
});

// // Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}
export default router;